import { motion } from 'framer-motion';
import { NEONVERSE } from '../constants';

const NeonStyles = () => (
  <section className="nv-section nv-section--tight" id="styles" style={{ paddingTop: 0 }}>
    <div className="nv-container">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.55 }}
      >
        <p className="nv-eyebrow">Genres</p>
        <h2 className="nv-title">Music Styles</h2>
        <p className="nv-lead">We produce music across virtually every genre.</p>
        <div className="nv-flow">
          {NEONVERSE.styles.map((s) => (
            <span key={s}>{s}</span>
          ))}
          <span>And many more</span>
        </div>
      </motion.div>
    </div>
  </section>
);

export default NeonStyles;
